import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as CustomerSelectors from "@/redux/modules/api/data/customer/customer.selectors";
import { update as updateAccountForms } from "@/redux/modules/value/accountForms/accountForms.module";
import { getAccountForms } from "@/redux/modules/value/accountForms/accountForms.selectors";
import { TAccountFormsState } from "@/redux/modules/value/accountForms/accountForms.types";

import RegisterForm from "./registerForm.component";

type Props = {
    title: string;
    buttonText: string;
    link: string;
    disclaimer: string;
};

const RegisterFormContainer = ({
    title,
    buttonText,
    link,
    disclaimer
}: Props) => {
    const accountForms = useSelector(getAccountForms());
    const isSubmitting = useSelector(CustomerSelectors.isLoading);
    const dispatch = useThunkDispatch();

    const update = (data: TAccountFormsState) => {
        return dispatch(updateAccountForms(data));
    };

    const onSubmit = (
        firstName: string,
        lastName: string,
        email: string,
        password: string
    ) => {
        dispatch(
            CustomerModule.register(email, firstName, lastName, password)
        ).then((action) => {
            if (action.type === CustomerModule.APIStatus.SUCCESS) {
                location.assign(link);
            }
        });
    };

    return (
        <RegisterForm
            title={title}
            buttonText={buttonText}
            isOpen={!!accountForms?.registerComponent}
            disclaimer={disclaimer}
            updateCardToggle={(isOpen) =>
                update({
                    loginComponent: false,
                    registerComponent: isOpen
                })
            }
            isSubmitting={isSubmitting}
            onSubmit={onSubmit}
        />
    );
};

export { RegisterFormContainer };
